import React from 'react';
import styles from './styles';

export default ({ tablesData, setTablesData, pageContent }) => {
  const cls = styles();
  const columnsDefault = tablesData?.columns_default || {};
  const columns = tablesData?.columns || {};

  const handleChangeColumn = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setTablesData((prev) => {
      return {
        ...prev,
        columns: {
          ...prev.columns,
          [name]: value,
        },
      };
    });
  };

  return (
    <div>
      <h3 className={cls.header}>COLUMNS</h3>
      <div className={cls.listContainer}>
        <table className={cls.list}>
          <thead>
            <tr>
              <th style={{ flex: 1 }}>COLUMN NAME</th>
              <th style={{ flex: 0.7 }}>XL COLUMN NAME</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(columnsDefault).map((key, index) => (
                <tr>
                  <td style={{ flex: 1 }}>{key.toUpperCase()}</td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{columns[key] || ''}</>
                    ) : (
                      <input
                        onChange={(e) => handleChangeColumn(e)}
                        type="text"
                        value={columns[key] || ''}
                        name={key}
                      />
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
